import React, { useReducer, useState } from "react";
import { Link } from 'react-router-dom';
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../elements/FormStyle/FormStyle.css';
import './RecoverPassword.css';

const formInputReducer = (state, input) => {
    if (input.type === 'reset') {
        return {
            email: '',
            scode: '',
            password: ''
        }
    }
    return {
        ...state,
        [input.name]: input.value
    }
}

const RecoverPassword = () => {
    const [formInputs, setFormInputs] = useReducer( formInputReducer, {
        email: '',
        scode: '',
        password: ''
    });
    const [info, setInfo] = useState('');
    const [passToggle, setPassToggle] = useReducer(state => !state, false);

    const handlePasswordRecovery = (e) => {
        e.preventDefault();
        axios.post('https://lerntutors.com/react_2026_api/resetpassword.php', formInputs)
        .then(res => res.data)
        .then(data => {
            if (data.status === 'success') {
                setInfo(data.message);
                if (data.message === 'Password reset successfully') {
                    setTimeout(() => {
                        setInfo('');
                        window.location.href = '/login';
                    }, 2000);
                }
            }
            else {
                alert(data.message);
            }
            setFormInputs({
                type: 'reset'
            })
        })
    }

    return (
        <div className="lern-recoverpassword">
            <div className="form-div">
                <form onSubmit={handlePasswordRecovery}>
                    {info !== '' && <div className="alert alert-success text-center">{info}</div>}
                    <fieldset>
                        <legend>Enter Your Email Address</legend>
                        <div className="form-group">
                            <input type="text" name="email" placeholder="Email Address" onChange={(e) => setFormInputs(e.target)} value={formInputs.email} required />
                        </div>
                        {
                            info !== '' && 
                            <div>
                                <div className="form-group">
                                    <input type="text" name="scode" placeholder="Reset Code" onChange={(e) => setFormInputs(e.target)} value={formInputs.scode} required />
                                </div>
                                <div className="form-group my-group">
                                    <input type={passToggle ? "text" : "password"} name="password" placeholder="New Password" onChange={(e) => setFormInputs(e.target)} value={formInputs.password} required />
                                    <span className="input-group-text btn btn-secondary" onClick={setPassToggle}>{passToggle ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}</span>
                                </div>
                            </div>
                        }
                        <div className="form-group btn-div">
                            <input type="submit" name="sub-btn" value={info !== '' ? "Reset" : "Submit"} />
                        </div>
                    </fieldset>
                </form>
                <div className="form-links">
                    <Link to="/login">Log In</Link>
                </div>
            </div>
        </div>
    )
}

export default RecoverPassword;